function refreshAllGrids() {
  window.dispatchEvent(new CustomEvent("food:grid:refresh-all"));
}

function refreshGridsOfResource(resource: string, resourceId?: string) {
  window.dispatchEvent(
    new CustomEvent("food:grid:refresh-resource", {
      detail: { resource, resourceId }
    })
  );
}

export { refreshGridsOfResource, refreshAllGrids };
